import { defineMessages } from 'react-intl';

/** The Legal tab (design settings-redesign e1-e5). */
export const legalMessages = defineMessages({
  subtitle: {
    id: 'app.sml.settings.legal.subtitle',
    defaultMessage: 'The documents that cover your use of MUSIC24, your privacy choices and your data.',
  },
  documents: { id: 'app.sml.settings.legal.documents', defaultMessage: 'Documents' },
  privacyPolicy: { id: 'app.sml.settings.legal.privacyPolicy', defaultMessage: 'Privacy policy' },
  termsOfService: { id: 'app.sml.settings.legal.termsOfService', defaultMessage: 'Terms of service' },
  refundPolicy: { id: 'app.sml.settings.legal.refundPolicy', defaultMessage: 'Refund policy' },
  imprint: { id: 'app.sml.settings.legal.imprint', defaultMessage: 'Imprint' },
  privacyChoices: { id: 'app.sml.settings.legal.privacyChoices', defaultMessage: 'Privacy choices' },
  forThisBrowser: { id: 'app.sml.settings.legal.forThisBrowser', defaultMessage: 'For this browser.' },
  cookieAccepted: {
    id: 'app.sml.settings.legal.cookie.accepted.description',
    defaultMessage:
      'Clarity, Google Analytics, the Meta pixel and our own usage analytics load only after you accept. Plausible counts visits without cookies and always runs.',
  },
  cookieRejected: {
    id: 'app.sml.settings.legal.cookie.rejected.description',
    defaultMessage: 'No analytics or ad tags load. Plausible counts visits without cookies and always runs.',
  },
  cookieNotSet: {
    id: 'app.sml.settings.legal.cookie.notSet.description',
    defaultMessage: 'You have not chosen yet. Nothing loads until you do.',
  },
  change: { id: 'app.sml.settings.legal.cookie.change', defaultMessage: 'Change' },
  choose: { id: 'app.sml.settings.legal.cookie.choose', defaultMessage: 'Choose' },
  yourData: { id: 'app.sml.settings.legal.yourData', defaultMessage: 'Your data' },
  whatWeStore: { id: 'app.sml.settings.legal.whatWeStore', defaultMessage: 'What we store' },
  whatWeStoreDescription: {
    id: 'app.sml.settings.legal.whatWeStore.description',
    defaultMessage: 'Your account, your workspace data and the analytics we keep.',
  },
  gdpr: { id: 'app.sml.settings.legal.gdpr', defaultMessage: 'Your rights under the GDPR' },
  gdprDescription: {
    id: 'app.sml.settings.legal.gdpr.description',
    defaultMessage: 'Access, correction, export and deletion, and how to ask.',
  },
  deleteTitle: { id: 'app.sml.settings.legal.delete', defaultMessage: 'Delete your account' },
  deleteDescription: {
    id: 'app.sml.settings.legal.delete.description',
    defaultMessage: 'In Account. It removes your sign-in and your workspace.',
  },
  openAccount: { id: 'app.sml.settings.legal.openAccount', defaultMessage: 'Open Account' },
});
